module.exports = __webpack_public_path__ + "images/guide-0a7275ed41.png";